import {
	comMapping
} from "@/components/util/Function/comMapping";
export function getdata() {
	var obj = {
		searchlist: [{
				prop: "businessMatchStatus",
				label: '处理状态',
				type: "select",
				selectval: comMapping.$businessMatchStatus
			},
			{
				prop: "businessType",
				label: '业务类型',
				type: "select"
			},
			{
				prop: "accountCode",
				label: '科目代码',
				type: "input"
			},
			{
				prop: "voucherDesc",
				label: '凭证摘要',
				type: "input"
			},
			{
				prop: "postingDate",
				label: '记账日期',
				type: "date",
				valueformat: 'yyyy-MM-dd'
			},
			{
				prop: "companyCode",
				label: '公司编号',
				type: "selectmore",
				width: "220px",
			},
			{
				prop: "voucherNo",
				label: '凭证号',
				type: "input"
			},
			{
				prop: "voucherDate",
				label: '凭证日期',
				type: "date",
				valueformat: 'yyyy-MM-dd'
			},
			{
				prop: "faphm",
				label: '发票号码',
				type: "input"
			},
			{
				prop: "billingNo",
				label: 'billing号',
				type: "input"
			},
			{
				prop: "kaiprq",
				label: '开票日期',
				type: "date",
				valueformat: 'yyyyMMdd'
			}
		],
		searchdata: {
			businessMatchStatus: "",
			businessType: "",
			accountCode: "",
			postingDate: [],
			voucherDesc: "",
			voucherDate: [],
			companyCode: "",
			voucherNo: "",
			faphm: "",
			billingNo: "",
			kaiprq: [],
		},
		headData: [{
				title: "公司编号",
				prop: "companyCode",
				width: "80",
				custom: true
			},
			{
				title: "科目代码",
				prop: "accountCode",
				width: "110",
				custom: true
			},
			{
				title: "凭证号",
				custom: true,
				prop: "voucherNo",
				width: 110,
			},
			{
				custom: true,
				title: "记账日期",
				prop: "postingDate",
				width: 110,
			},
			{
				custom: true,
				title: "凭证日期",
				prop: "voucherDate",
				width: 110,
			},
			{
				title: "凭证摘要",
				custom: true,
				prop: "voucherDesc",
				width: 110,
			},
			{
				title: "业务类型",
				custom: true,
				prop: "businessType",
				width: 100,
			},
			{
				title: "处理状态",
				custom: true,
				prop: "businessMatchStatus",
				width: 100,
			},
			{
				title: "billing号",
				custom: true,
				prop: "billingNo",
				width: 100,
			},
			{
				title: "记账金额",
				custom: true,
				prop: "localAmount",
				width: 100,
			},
			{
				title: "发票税额",
				custom: true,
				prop: "shuiehj",
				width: 100,
			},
			{
				title: "发票号码",
				custom: true,
				prop: "faphm",
				width: 170,
			},
			{
				title: "开票日期",
				custom: true,
				prop: "kaiprq",
				width: 110,
			},
			{
				title: "参考字段一",
				custom: true,
				prop: "reference1",
				width: 100,
			},
			{
				title: "参考字段二",
				custom: true,
				prop: "reference2",
				width: 100,
			},
			{
				title: "参考字段三",
				custom: true,
				prop: "reference3",
				width: 100,
			},
			{
				title: "参考字段四",
				custom: true,
				prop: "reference4",
				width: 100,
			},
			{
				title: "参考字段五",
				custom: true,
				prop: "reference5",
				width: 100,
			},
			{
				title: "备注",
				custom: true,
				prop: "businessMatchRemark",
				width: 100,
			},
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		}
	}
	return obj
}
